import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { Autocomplete, Box, Typography } from "@mui/material";
import { useQuery } from "@tanstack/react-query";
import { useFormikContext } from "formik";
import { useMemo } from "react";
import useAPI from "../../../../../api/hooks/useAPI";
import { serviceNowKeys } from "../../../../../api/queryKeys";
import AnchorPopper from "../../../../../components/forms/AnchorPopper";
import {
  StyledTextField,
  getTextFieldInputProps,
  textFieldLabelProps,
} from "../../../../../components/forms/styles/formFieldStyles";

const ServiceNowCategory = () => {
  const { values, errors, touched, handleBlur, setFieldValue } =
    useFormikContext();
  const { getServiceNowCategories } = useAPI();

  const hasError = !!touched.category && !!errors.category;
  const errorMessage =
    hasError && typeof errors.category === "string" ? errors.category : "";

  const categoryLabel = useMemo(() => {
    const hasValue = values.category;
    const labelText = hasValue ? "Category" : "Select category";

    return <Typography variant="caption">{labelText}</Typography>;
  }, [values.category]);

  const { data: categoryOptions = [], isLoading } = useQuery({
    queryKey: serviceNowKeys.categories,
    queryFn: async () => {
      const response = await getServiceNowCategories();
      return response.data || [];
    },
  });

  return (
    <Autocomplete
      options={categoryOptions}
      value={
        categoryOptions.find((option) => option.value === values.category) ||
        null
      }
      onChange={(_, newValue) =>
        setFieldValue("category", newValue?.value || "")
      }
      getOptionLabel={(option) => option?.label || ""}
      isOptionEqualToValue={(option, value) => option?.value === value?.value}
      popupIcon={<ExpandMoreIcon />}
      PopperComponent={AnchorPopper}
      loading={isLoading}
      renderOption={(props, option) => (
        <Box component="li" {...props}>
          <Typography variant="caption">{option.label}</Typography>
        </Box>
      )}
      renderInput={(params) => (
        <StyledTextField
          {...params}
          margin="dense"
          label={categoryLabel}
          fullWidth
          required
          error={hasError}
          helperText={errorMessage}
          onBlur={handleBlur}
          InputProps={getTextFieldInputProps(params.InputProps)}
          InputLabelProps={textFieldLabelProps(params.InputLabelProps)}
        />
      )}
    />
  );
};

export default ServiceNowCategory;
